// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_2IaI_ORqpioeR697pOmPE5","spaceLeft":"D0ynUAjJOQvxYymwH_yCG","spaceBoth":"_3Vv59CdZmfqsJEoEFHwJrp","spaceRight":"ys4-0a0GVA44hi5-8oyKy","link":"_32VzdKvbpmQhrhoKHYLHZ_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EtherscanLink.scss
// module id = 1236
// module chunks = 0